var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-modal',{attrs:{"visible":_vm.isLoading,"centered":"","no-close-on-backdrop":"","no-close-on-esc":"","hide-header":"","hide-footer":"","content-class":"bg-transparent border-0"}},[_c('div',{staticClass:"text-center"},[_c('div',{staticClass:"spinner-border text-light",attrs:{"role":"status"}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }